import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { InstanceService } from '../../core/services/instance.service';
import { catchError, take } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { Instance } from '../../base/entities/transport.interface';
import { AsyncPipe } from '@angular/common';
import { InstanceComponent } from '../instance/instance.component';

@Component({
  selector: 'app-instance-container',
  standalone: true,
  imports: [InstanceComponent, AsyncPipe],
  template: ` @if (instance$ | async; as instance) {
    <app-instance
      [instance]="instance"
      [showLocation]="showLocation"
    />
  }`
})
export class InstanceContainerComponent implements OnInit {
  private readonly instanceService = inject(InstanceService);
  instance$: Observable<Instance>;

  @Input() transportId: string;
  @Input() showLocation: boolean;
  @Output() failed = new EventEmitter();

  ngOnInit(): void {
    this.instance$ = this.instanceService.getInstanceByTransportId(this.transportId).pipe(
      take(1),
      catchError(() => {
        this.failed.emit();
        return EMPTY;
      })
    );
  }
}
